import { map, path, pathOr } from 'ramda'
import { connect } from 'react-redux'
import { bindActionCreators, compose } from 'redux'

import { toggleCallDialog } from '@/app/module/user/store/actions'
import { selectOrgId, selectUserId, selectUserTimezone } from '@/app/module/user/store/selectors'
import config from '@/config'

import { selectToken } from '../auth/store/selectors'
import Item from './components/item'
import ResponsiveSubs from './components/responsive-subs'
import {
  closeCATISurvey,
  getCATIItem,
  getCATIStep,
  getOrgSubs,
  getSubDetails,
  navigateOrgSubs,
  setCATISubsPageSize,
  setSubStatus,
} from './store/actions'
import { selectHeaders, selectSubsContactValues } from './store/selectors'

export const pageSizeValues = compose(
  map((val) => ({ label: val, value: val })),
  path(['modules', 'cati', 'pageSize', 'values']),
)(config)

const pageSizeDefault = path(['modules', 'cati', 'pageSize', 'default'], config)

const catiItemSelector = ({ cati, user }) => ({
  token: selectToken(),
  orgId: selectOrgId({ user }),
  campaign: pathOr({}, ['item', 'data', 'campaign'], cati),
  contact: pathOr({}, ['item', 'data', 'contact'], cati),
  done: pathOr(false, ['item', 'data', 'done'], cati),
  loading: cati.item.loading,
  error: cati.item.error,
  data: cati.item.data,
})

const catiItemDispatcher = (dispatch) =>
  bindActionCreators(
    {
      getCATIItem,
      getCATIStep,
      toggleCallDialog,
      getSubDetails,
      setSubStatus,
      closeCATISurvey,
    },
    dispatch,
  )

export const CATIItem = connect(catiItemSelector, catiItemDispatcher)(Item)

const catiSubsSelector = ({ user, cati, utils }) => ({
  token: selectToken(),
  orgId: selectOrgId({ user }),
  userId: selectUserId({ user }),
  loading: user.details.loading || !cati.subs.initialized || cati.subs.loading,
  values: selectSubsContactValues({ cati }),
  headers: selectHeaders(),
  total: pathOr(0, ['subs', 'data', 'total'], cati),
  pageSizeValues,
  size: pathOr(pageSizeDefault, ['subs', 'data', 'size'], cati),
  timezone: selectUserTimezone({ user, utils }),
})

const catiSubsDispatcher = (dispatch) =>
  bindActionCreators(
    {
      getOrgSubs,
      setPageSize: setCATISubsPageSize,
      navigate: navigateOrgSubs,
    },
    dispatch,
  )

export const CATISubs = connect(catiSubsSelector, catiSubsDispatcher)(ResponsiveSubs)
